import {
  AutocompleteItem,
  AutocompleteSelect,
} from '@prismamedia/one-components';
import { GetCategoryQuery_category_Category } from '__generated__/queries-recipe';
import { FC, useEffect, useState } from 'react';
import { useFetchCategories } from './useFetchCategories';

interface CategorySelectProps {
  label: string;
  category?: GetCategoryQuery_category_Category | null;
  onSelect?: (category: GetCategoryQuery_category_Category | null) => void;
  className?: string;
  brandKey: string | null;
  displayCount?: boolean;
}

export const CategorySelect: FC<CategorySelectProps> = ({
  label: inputLabel,
  category,
  onSelect,
  className,
  brandKey,
  displayCount,
}) => {
  const [value, setValue] = useState<AutocompleteItem | undefined>(undefined);

  const fetchCategories = useFetchCategories(brandKey, displayCount);

  useEffect(() => {
    setValue(category ? { id: category.id, label: category.title } : undefined);
  }, [category]);

  return (
    <AutocompleteSelect
      label={inputLabel}
      value={value}
      className={className}
      fetchList={fetchCategories}
      onChange={(item) => {
        onSelect && onSelect(item?.additionnals?.category || null);
      }}
    />
  );
};
